<template>
  <div id="app" style="position:relative;">
    <main style="display:flex;flex-direction:column;justify-content:center;align-items:center;position:relative;">
      <header-component v-if="$store.state.header.title && !['/', '/onboard', '/api'].includes($router.currentRoute.path) && !this.$store.state.helper.loading"></header-component>
      <router-view></router-view>
      <nav-component v-if="$store.state.navNodes.length && !['/', '/onboard', '/api'].includes($router.currentRoute.path) && !this.$store.state.helper.loading"></nav-component>
      <helper-component v-if="$store.state.helper.notif"></helper-component>
      <settings-component v-if="$store.state.helper.settings"></settings-component>
      <cookies-component v-if="!$store.state.cookieAccepted"></cookies-component>
      <trunc-component v-if="$store.state.showTrunc"></trunc-component>
      <hover-component v-if="$store.state.hover.hover"></hover-component>
      <loading-component v-if="$store.state.helper.loading && $screen.breakpoint !== 'sm'"></loading-component>
      <mobile-loading-component v-if="$store.state.helper.loading && $screen.breakpoint === 'sm'"></mobile-loading-component>
    </main>
    <div v-if="$store.state.changedOrientation" class="orientation-overlay">
        <img src="@/assets/rotate.png" />
    </div>
  </div>
</template>

<script>

import Header from './components/util/Header';
import Helper from './components/helper/Notif';
import Nav from './components/util/Nav';
import Settings from './components/settings/Settings';
import Loading from './components/util/Loading';
import Cookies from './components/util/Cookies';
import MobileLoading from './components/util/MobileLoading';
import Trunc from './components/util/Truncator';
import Hover from './components/util/Hover';

export default {

  name: 'app',

  data(){
    return {
      initialOrientation: ''
    }
  },

  methods: {


    assessCookies(){
      if (this.$cookies.get('breeziProAcceptCookies') === null) {
        this.$store.dispatch('setCookieToState', false);
      }
    }

  },

  components: {
    'helper-component': Helper,
    'header-component': Header,
    'nav-component': Nav,
    'settings-component': Settings,
    'loading-component': Loading,
    'cookies-component': Cookies,
    'mobile-loading-component': MobileLoading,
    'trunc-component': Trunc,
    'hover-component': Hover
  },

  mounted(){
    this.assessCookies();
    this.$store.dispatch('blockOrientation', false);
    this.initialOrientation = this.$screen.width > this.$screen.height ? 'landscape' : 'portrait';
  },

  watch: {
    '$screen.width': function(newWidth, oldWidth){
      if (this.initialOrientation == 'portrait' && newWidth > this.$screen.height) {
        this.$store.dispatch('blockOrientation', true)
      } else {
        this.$store.dispatch('blockOrientation', false);
      }
    }
  }

}
</script>

<style>

body {
  margin: 0;
}

#app {
  font-family: 'Comfortaa', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #dce1ec;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.component-main {
  height: calc(100vh - 180px);
  width: 98vw;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
}

.ob-main {
  width: 100vw;
  height: 100vh;
  background: transparent;
}

.tilt-main {
  background: url('https://brebe-s3-storage-matt.s3-eu-west-1.amazonaws.com/breezi-pro/city_center+copy.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.dark-overlay {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(1px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.land-btn {
  width: 160px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  align-self: center;
  justify-self: center;
  margin: 10px;
  cursor: pointer;
  text-align: center;
}

.prim-btn {
  background-color: rgba(86, 189, 78, 0.4);
  background-filter: blur(3px);
  border: 2px solid rgb(86, 189, 78);
}

.prim-btn:hover {
  background-color: rgb(86, 189, 78);
}

.sec-btn {
  background-color: rgba(231, 165, 85, 0.4);
  background-filter: blur(3px);
  border: 2px solid rgb(231, 165, 85);
}

.sec-btn:hover {
  background-color: rgb(231, 165, 85);
}

.tre-btn {
  background-color: rgba(17, 112, 234, 0.4);
  background-filter: blur(3px);
  border: 2px solid rgb(17, 112, 234);
}

.tre-btn:hover {
  background-color: rgb(17, 112, 234);
}

.alert-btn {
  background-color: rgba(163, 26, 28, .7);
  border: 2px solid rgb(163, 26, 28);
}

.alert-btn:hover {
  background-color: rgb(163, 26, 28);
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0);
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 153, 191, 0.8);
}

.ob-outer {
  width: 500px;
  max-width: 98%;
  height: 750px;
  max-height: 98%;
  background-color: #3f3f41;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ob-header {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 3px solid rgb(0, 153, 191);
  background-color: rgba(0, 153, 191, 0.3);
  position: relative;
}

.ob-img {
  height: 80px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(0, 153, 191);
}

.ob-img img {
  height: 40px;
}

.ob-header h3 {
  margin-right: 10px;
  width: calc(100% - 80px);
}

.ob-back {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(0, 153, 191);
  cursor: pointer;
  border-radius: 100%;
  font-weight: bolder;
  font-size: 1.5em;
}

.ob-back:hover {
  background-color: rgb(220, 225, 236);
}

.ob-body {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.ob-input {
  width: 250px;
  height: 30px;
  background: none;
  box-shadow: none;
  border: none;
  border-bottom: 2px solid #dce1ec;
  margin-bottom: 5px;
  font-size: 1.3em;
  color: #dce1ec;
  border-radius: 0px;
}

.ob-label {
  width: 230px;
  text-align: left;
  font-size: 0.85em;
}

.ob-btns {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 10px;
}

.ob-btn {
  width: 100px;
  height: 50px;
}

.card {
  background-color: #333237;
  border-radius: 4px;
  width: 325px;
  height: 500px;
  margin: 5px;
  cursor: pointer;
}

.battery {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 22px;
}

.battery img {
  height: 75%;
  margin-right: 4px;
  margin-bottom: 2px;
}

.refresh-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.85);
  animation: fadeinout 4s linear forwards;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes fadeinout {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.warn-btn {
  background-color: rgba(207, 64, 66, 0.85);
  border: 2px solid #ff002d;
}



.tooltip {
  display: block !important;
  z-index: 10000;
  overflow: visible;
  background: none;
  /* width: 0px;
  min-width: 120px;
  max-width: 300px; */
}

.tooltip .tooltip-inner {
  padding: 0px;
  border-radius: 0px;
  /* background: #404342;
  color: lightblue;
  border-radius: 6px;
  padding: 8%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #dce1ec;
  font-weight: 400;
  overflow: hidden;
  word-wrap: nowrap;
  white-space: nowrap;
  min-width: 150px; */
  font-family: 'Comfortaa', sans-serif;
  overflow: visible;
  background: none;
}

.tooltip.popover .popover-inner {
  /* min-width: 120px; */
  /* min-height: 40px; */
  white-space: normal;
  overflow: visible;
  background: none;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  background: #404342;
  z-index: 1;
  display: none;
}

.tooltip.popover .popover-inner {
  background: rgba(0,0,0,0);
  border: none;
  padding: none;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="top-end"] {
  margin-left: 120px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-arrow {
  /* border-color: #f9f9f9; */
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;;
}

.parent-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: rgb(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  backdrop-filter: blur(1.5px);
}

.parent-overlay h6 {
  text-align: center;
  /* background: gray; */
  margin: 0px;
  padding: 2px;
  width: 100%;
}

.on-off {
  width: 85%;
  height: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  position: relative;
  overflow: visible;
}

.on-off h6 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
  font-size: 0.6em;
}

.on-off img {
  height: 20px;
  width: 20px;
  margin-bottom: 5px;
}

.orientation-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: rgb(0, 153, 191);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.orientation-overlay img {
  height: 150px;
}

.voc-acc {
  width: 50%;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.acc-node {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin-left: 5px;
  margin-left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue